import {isObject} from 'lodash-es'
import {findObjectAuthCode} from 'fe-coms-share/paas'
import projectInfo from '../../../utils/project-info'
import {CUSTOM_OBJECT_AUTH_CODE} from 'fe-coms-share/paas/constants'

const relationshipSchemaHandle = {
  handle (node, {info: {objectApiName, _objectApiName}, layoutApiName, app, ability = {}}) {
    const {props, linkObjectApiName, sequenceCode, appRelationPageVOS} = node
    const {
      relateObjectApiName,
      relateListApiName,
      tenantType
    } = (appRelationPageVOS || []).find(v => v.tenantType === projectInfo.query()) || {}
    // 判断有无关联列表页, 有则判断有无当前对象的列表权限
    const listAuth = findObjectAuthCode(relateObjectApiName, CUSTOM_OBJECT_AUTH_CODE.LIST)
    // 能力相关参数
    const abilityConfig = ability[sequenceCode]
    const interfacesGetList = abilityConfig?.interfaces?.getList
    const interfacesGetValue = abilityConfig?.interfaces?.getValue
    const abilityResponseParams = interfacesGetList?.responseParams

    return {
      props: {
        ...props,
        params: {
          relateObjectApiName: relateObjectApiName || linkObjectApiName,
          apiName: node.apiName,
          objectApiName,
          _objectApiName,
          layoutApiName,
          // 从对象
          listLayoutApiName: relateListApiName,
          tenantType: tenantType || app
        },
        layoutApiName,
        tenantType: tenantType || app,
        interfacesGetList,
        interfacesGetValue,
        abilityResponseParams,
        showAddIcon: listAuth && tenantType === projectInfo.query()
      }
    }
  }
}

const relationshipProps = {
  placeholder: {
    type: String
  },
  value: {
    type: [String, Object],
    default: () => ({})
  },
  // 查找关联额外参数
  params: {
    type: Object,
    default: () => ({})
  },
  // 是否只读
  disabled: {
    type: Boolean,
    default: false
  },
  showAddIcon: {
    type: Boolean,
    default: false
  },
  // 租户类型
  tenantType: {
    type: String,
    default: 'pur'
  },
  // 布局
  layoutApiName: {
    type: String,
    default: ''
  },
  sequenceId: String,
  // 调整尺寸
  size: {
    type: String,
    default: 'small'
  },
  isPureText: {
    type: Boolean,
    default: false
  },
  showTooltip: {
    type: Boolean,
    default: true
  },
  interfacesGetList: {
    type: Object
  },
  interfacesGetValue: {
    type: Object
  },
  abilityResponseParams: {
    type: Object
  },
  // 关联对象
  linkObjectApiName: {
    type: String,
    default: ''
  },
  // 关联权限
  linkOperationApiName: {
    type: String,
    default: ''
  },
  // 行数据 id
  id: {
    type: String,
    default: ''
  }
}

export const lookupRelationshipProps = relationshipProps
export const lookupRelationshipSchemaHandle = relationshipSchemaHandle

export const masterDetailRelationshipProps = relationshipProps
export const masterDetailRelationshipSchemaHandle = relationshipSchemaHandle

export function initValue (val, key) {
  return isObject(val) ? val[key] : val
}